import { render, staticRenderFns } from "./RelatorioSaude.vue?vue&type=template&id=6209e096&scoped=true&"
import script from "./RelatorioSaude.vue?vue&type=script&lang=js&"
export * from "./RelatorioSaude.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioSaude.vue?vue&type=style&index=0&id=6209e096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6209e096",
  null
  
)

export default component.exports